import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contentSearch", "contentId", "dropdown", "contentPlaceholder", "contentImage"]
  static values = {
    searchUrl: String,
    prefillContentId: String,
    prefillContentName: String,
    prefillContentImageUrl: String
  }

  connect() {
    this.debounceTimer = null
    this.boundHideDropdown = this.hideDropdown.bind(this)
    document.addEventListener("click", this.boundHideDropdown)
    if (this.prefillContentIdValue) {
      this.contentSearchTarget.value = this.prefillContentNameValue
      this.contentIdTarget.value = this.prefillContentIdValue
      this.showImage(this.prefillContentImageUrlValue)
    }
  }

  disconnect() {
    clearTimeout(this.debounceTimer)
    document.removeEventListener("click", this.boundHideDropdown)
  }

  search() {
    clearTimeout(this.debounceTimer)
    const query = this.contentSearchTarget.value.trim()

    if (query.length < 2) {
      this.clearDropdown()
      if (query.length === 0) this.clearContent()
      return
    }

    this.debounceTimer = setTimeout(() => this.fetchResults(query), 300)
  }

  fetchResults(query) {
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(query)}`

    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(r => r.json())
      .then(results => this.renderDropdown(results))
  }

  renderDropdown(results) {
    if (results.length === 0) {
      this.dropdownTarget.innerHTML = '<div class="fandom-dropdown-empty">No results found</div>'
      this.dropdownTarget.classList.remove("d-none")
      return
    }

    this.dropdownTarget.innerHTML = results.map(c =>
      `<div class="fandom-dropdown-item"
            data-action="click->fandom-form#selectContent"
            data-content-id="${c.id}"
            data-content-name="${c.name}"
            data-content-image-url="${c.image_url || ''}">${c.name}</div>`
    ).join("")
    this.dropdownTarget.classList.remove("d-none")
  }

  selectContent(event) {
    const item = event.currentTarget
    this.contentSearchTarget.value = item.dataset.contentName
    this.contentIdTarget.value = item.dataset.contentId
    this.showImage(item.dataset.contentImageUrl)
    this.clearDropdown()
  }

  showImage(url) {
    if (url) {
      this.contentImageTarget.src = url
      this.contentImageTarget.classList.remove("d-none")
      this.contentPlaceholderTarget.classList.add("d-none")
    } else {
      this.showPlaceholder()
    }
  }

  clearContent() {
    this.contentIdTarget.value = ""
    this.showPlaceholder()
  }

  showPlaceholder() {
    this.contentImageTarget.src = ""
    this.contentImageTarget.classList.add("d-none")
    this.contentPlaceholderTarget.classList.remove("d-none")
  }

  clearDropdown() {
    this.dropdownTarget.innerHTML = ""
    this.dropdownTarget.classList.add("d-none")
  }

  hideDropdown(event) {
    if (!this.element.contains(event.target)) {
      this.clearDropdown()
    }
  }
}
